export class ODataSkip{
    constructor(private skip:number){
        
    }

    public toString():string{
        return this.skip.toString();
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/utility/odata/odata-skip.ts